<template>
  <div class="hospital-db-layout">
    <layout-header></layout-header>
    <div class="hospital-db-layout-content">
      <router-view />
      <!-- <layout-footer></layout-footer> -->
    </div>
  </div>
</template>

<script>
import LayoutHeader from "./layoutHeader";
import LayoutFooter from "./layoutFooter";
export default {
  components: { LayoutHeader, LayoutFooter },
};
</script>

<style>
</style>